import * as PapaParse from 'papaparse';
import handleFileDownload from '../handleFileDownload';
import { chaptersourceToAutomatedAnswer } from '../../transform/automatedAnswer';
import { NODE_TYPES } from '../../../constants/flowGraph';

export const AA_INNER_DELIMITER = '///';

/**
 * A helper function to export automated answers as csv file
 *
 * @param {Array} automatedAnswersToExport The collection of automated answers to export.
 * @param {string} primaryBotLanguage The primary bot language.
 * @param {string} delimiter (optional) The inner delimiter symbol - defaults to AA_INNER_DELIMITER.
 * @returns {void}
 */
const exportAutomatedAnswers = async (automatedAnswersToExport, primaryBotLanguage, delimiter = AA_INNER_DELIMITER) => {
  const csvContents = automatedAnswersToExport
    .map(a => chaptersourceToAutomatedAnswer(a, primaryBotLanguage))
    .map(a => {
      let csvData = {
        'ID': a.id
      };

      // Add name per language (a.name)
      Object.keys(a.name).forEach(language => {
        csvData[`${language.toUpperCase()}.Name`] = a.name[language];
      });

      // Add group per language (a.group)
      Object.keys(a.group).forEach(language => {
        csvData[`${language.toUpperCase()}.Group`] = a.group[language];
      });

      // Add tags (a.tags)
      Object.keys(a.tags).forEach(language => {
        csvData['Tags'] = a.tags.join(delimiter);
      });

      // Add examples per language
      Object.keys(a.nlpTrainingData.examples).forEach(language => {
        csvData[`${language.toUpperCase()}.Examples`] = a.nlpTrainingData.examples[language].join(delimiter);
      });

      // Add responses and jump per language
      a.responses.forEach((response, index) => {
        if (response.type === NODE_TYPES.MESSAGE) {
          response.options.forEach(option => {
            // An option is a key value pair of language and response per language
            // Like { el: 'Greek response1', en: 'English response1', fr: 'French response1' }
            Object.keys(option).forEach(language => {
              csvData[`${language.toUpperCase()}.Responses`] = csvData[`${language.toUpperCase()}.Responses`] || '';
              // Join responses with delimiter
              csvData[`${language.toUpperCase()}.Responses`] = csvData[`${language.toUpperCase()}.Responses`] + (index > 0 ? delimiter : '') + option[language];
            });
          });
        } else if (response.type === NODE_TYPES.JUMP) {
          csvData['Redirect'] = response.jumpTo;
        }
      });

      return csvData;
    });

  // PapaParse needs the columns to be specified manually in case not all are specified in the first object
  // so we need to go through all object keys and generate the columns array
  const columnNames = Object.keys(csvContents.reduce((acc, obj) => {
    Object.keys(obj).forEach(key => {
      acc[key] = true;
    });
    return acc;
  }, {}));

  var csv = PapaParse.unparse(csvContents, { columns: columnNames });

  var csvData = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const fileName = 'automated_answers.csv';
  handleFileDownload(csvData, fileName);
};

export default exportAutomatedAnswers;
